<template>
    <section class="admin-workshops-section half-cut-bg">
      <List></List>
    </section>
  </template>
  <script>
  /* eslint-disable */ 
  import AppMixin from '../../mixins/AppMixin'
  import List from '../common/consulting-hours/List.vue'
  export default {
    name: 'AdminConsultingHours',
    mixins: [AppMixin],
    components: {
      List
    },
    data() {
      return {
  
      }
    },
    methods: {
  
  
    },
    mounted() {
  
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/ConsultingHours.vue